import { CustomerCodeMessage } from "./CustomerFormStyles";
import Paragraph from "@vfuk/core-paragraph";
import { t } from "i18next";

const CustomerFormPid = () => {
  return (
    <CustomerCodeMessage>
      <Paragraph id="pidMessage">{t("core:customers:pid_text")}</Paragraph>
    </CustomerCodeMessage>
  );
};
export default CustomerFormPid;
